module.exports = __webpack_public_path__ + "img/serifnew_box05.ea75aded.jpg";